import { element } from 'protractor';
import { ReportsService } from 'src/app/services/reports.service';
import { UserDetailResult } from './../../../model/UserDetail';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { ProductService } from 'src/app/services/product.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { DataServiceService } from 'src/app/services/data-service.service';
import { UserModel } from 'src/app/model/UserModel';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { LteActiveSession } from 'src/app/model/LteActiveSessions';
import { environment } from 'src/environments/environment';
import { DataUnitofMeasureInfo } from 'src/app/model/selfcareproducts';
import { XDRModel } from 'src/app/model/XDRModel';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-currentdata',
  templateUrl: './currentdata.component.html',
  styleUrls: ['./currentdata.component.css']
})
export class CurrentdataComponent implements OnInit {

  currentUser: UserModel;
  firstname: any;
  accType: string;
  activeProducts: any[];
  MDN1: any;
  planstatus: string;
  planname: string;
  userdetail: UserDetailResult;
  currentUsage: string;
  daysLeft: string;
  activationDate: string;
  expirationDate: string;
  initloading: boolean = false;
  title: string;
  filterName: string = "Last week";
  @ViewChild('lineChart') private chartRef;
  chart: any;
  selectedOptions: any;
  config = {
    displayKey: "Display", //if objects array passed which key to be displayed defaults to description
    search: true,
    height: '180px',
    searchOnKey: 'Display'
  };


  constructor(private toastr: ToastrService, private router: Router, private sharedService: SharedService, private productService: ProductService, private authenticationService: AuthenticationService, private accountService: AccountService, private dataService: DataServiceService, private reportService: ReportsService) {

    this.currentUser = this.authenticationService.getCurrentUser();

    this.firstname = this.currentUser.FirstName;


    if(this.currentUser.i_Account == "0")
    {
   let KycStatus :string = this.currentUser.KycStatus;

   if(KycStatus)
   {
    if(KycStatus.toLowerCase() === "Rejected".toLowerCase() || KycStatus.toLowerCase() === "No Kyc".toLowerCase())
    { 
      this.router.navigate(['/kyc']); 

    }


   }
  }

    this.dataService.currentAccountType.subscribe(acc => {
      this.accType = acc;
      this.fetchAccounts();

    });
  }

  ngOnInit() {
  }

  async selectionChanged(e) {
    if (e.value) {
      var acc = e.value.i_account;

      await this.getAccountDetail(acc);
    }
  }

  DisplayChart(label: any[], data: any[]) {

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(this.chartRef.nativeElement, {
      type: 'line',
      data: {
        labels: label,
        datasets: [{
          label: 'Data Usage (MB)',
          data: data,
          fill: false,
          borderColor: [
            '#428bca'
          ],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });

  }

  async FilterUsageReport(days: number, filter: string) {


    let dynamicDate = new Date().setDate(new Date().getDate() - days);
    let endday = new Date().toLocaleDateString();
    let startday = new Date(dynamicDate).toLocaleDateString();

    var resultArr = [];
    var dateArr = [];
    var mbUsageArr = [];

    let usageResult = await this.reportService.LTEGetUsageReportWithDateString(this.userdetail.i_account, this.userdetail.i_customer, startday, endday).toPromise();

    if (!usageResult.Result) {
      this.toastr.error(environment.GenericErrorMsg, "Error");
      return;
    }

    let usage: XDRModel[] = usageResult.Result;

    usage.forEach(element => {

      var date = new Date(element.bill_time).toLocaleDateString();
      var index = dateArr.indexOf(date);

      if (index == -1) {
        dateArr.push(date);
        var obj = { Date: date, Mb: element.charged_quantity };
        resultArr.push(obj);
      }
      else {
        resultArr[index].Mb += element.charged_quantity;
      }

    });

    mbUsageArr = resultArr.map(a => { return a.Mb });

    this.DisplayChart(dateArr, mbUsageArr);
    this.filterName = filter;
  }

  async getAccountDetail(i_account) {

    try {

      let reqObj = {
        i_account: i_account
      }

      let millisecondsInDays = 86400000;
      let today =new Date().setHours(0,0,0,0);
      var model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
      model.i_account = i_account;
      model.DownloadType = "ACC:GetDetail";

      //let userDetailResult = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
      let userDetailResult = await this.accountService.getAccountDetailFromLteHttp(model.i_account).toPromise();

      if (!userDetailResult) {
        this.toastr.error(environment.GenericErrorMsg, "Error");
        return;
      }

      //this.userdetail = userDetailResult.Result[0];
      this.userdetail = userDetailResult.Result;

      if (!this.userdetail.i_account) {
        this.toastr.error(environment.GenericErrorMsg, "Error");
        return;
      }

      let noOfDays = new Date().setDate(new Date().getDate() - 7);
      let endday = new Date().toLocaleDateString();
      let startday = new Date(noOfDays).toLocaleDateString();



      let userdetail = this.userdetail;
      let voiceproduct = userdetail.Product.Name.toLowerCase().includes("voice");

      let resultArr = [];
      let dateArr = [];
      let mbUsageArr = [];

      this.planname = userdetail.Product.Name;
      this.setStatus(userdetail.AccountState);
      this.activationDate = new Date(userdetail.ActivationDate).toDateString();
      this.MDN1 = userdetail.AccountName ? userdetail.AccountName : userdetail.ID;


      if (voiceproduct) {

        this.currentUsage = "₦" + userdetail.Balance.toLocaleString();
        this.title = "Voice";

      } else {

        let usageResult = await this.reportService.LTEGetUsageReportWithDateString(i_account, this.userdetail.i_customer, startday, endday).toPromise();
        let usage: XDRModel[] = usageResult.Result;
        this.currentUsage = parseFloat((Math.round((userdetail.DataVolume) * 100) / 100).toString()).toFixed(2) + " " + DataUnitofMeasureInfo[userdetail.Product.Display.DataCapacity.UnitofMeasure] + " left";
        this.title = "Data";
        let expiryDate = Date.parse(userdetail.ExpirationDate.toString());
        let daysLeft = Math.round((expiryDate - today) / millisecondsInDays);
        this.daysLeft = daysLeft < 0 ? "" : daysLeft + " days left";
        this.expirationDate = new Date(userdetail.ExpirationDate).toDateString();
        
        if (usage) {
          usage.forEach(element => {

            let date = new Date(element.bill_time).toLocaleDateString();
            let index = dateArr.indexOf(date);

            if (index == -1) {
              dateArr.push(date);
              var obj = { Date: date, Mb: element.charged_quantity };
              resultArr.push(obj);
            }
            else {
              resultArr[index].Mb += element.charged_quantity;
            }

          });

          mbUsageArr = resultArr.map(a => { return a.Mb });
          this.DisplayChart(dateArr, mbUsageArr);
        }



      }





    }
    catch (err) {
      this.toastr.error(environment.GenericErrorMsg, "Error");
    }

  }

  async getSelectedAccount(i_account) {
    await this.getAccountDetail(i_account);
  }

  async fetchAccounts() {

    var my_object = this.currentUser;
    let activeSessionRequest: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    activeSessionRequest.DownloadType = "ACC:GetDetail";

    if (my_object) {
      var iAccount = parseInt(my_object.i_Account);

      if (iAccount == 0)   //  customer with multiple accounts
      {
        //an individual
        activeSessionRequest.i_customer = parseInt(my_object.i_Customer);
        await this.setActiveSession(activeSessionRequest);

      }
      else  // single account
      {
        activeSessionRequest.i_account = parseInt(my_object.i_Account);
        this.setActiveSession(activeSessionRequest);
      }

    }
  }

  async setActiveSession(model: ActiveSessionsReqObj) {

    if (model) {
      let res = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
      if (!res.Result) {
        this.toastr.error("An error occured, Couldn't get active sessions", "Error");
        return;
      }
      let activeSessions: LteActiveSession[] = [] as LteActiveSession[];
      if (this.accType == "VOICE") {
        activeSessions = <LteActiveSession[]>res.Result.filter(a => a.Product.Name.toLowerCase().includes("voice"));
      } else {
        activeSessions = <LteActiveSession[]>res.Result.filter(a => !a.Product.Name.toLowerCase().includes("voice"));
      }

      this.activeProducts = activeSessions.map(a => {
        return <any>{
          AccountName: a.AccountName,
          ID: a.ID,
          i_account: a.i_account,
          Display: a.subscriber.FirstName ? a.subscriber.FirstName + ' - ' + a.ID : a.ID,
          subscriber: a.subscriber
        }
      });

      var firstAcc = this.activeProducts[0];

      this.selectedOptions = {
        AccountName: firstAcc.AccountName,
        ID: firstAcc.ID,
        i_account: firstAcc.i_account,
        Display: firstAcc.subscriber.FirstName ? firstAcc.subscriber.FirstName + ' - ' + firstAcc.ID : firstAcc.ID
      }
      this.MDN1 = firstAcc.AccountName ? firstAcc.AccountName : firstAcc.ID;
      await this.getAccountDetail(firstAcc.i_account);

    }
  }

  Renewal() {


    let account = this.userdetail;
    if (!account) {
      return;
    }
    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.router.navigateByUrl('/renewplanvoice?acc=' + this.userdetail.i_account);
      return;
    }

    this.router.navigateByUrl('/renewplan?acc=' + this.userdetail.i_account);

  }

  topupdata() {

    let account = this.userdetail;

    if (!account) {
      return;
    }

    if (account.AccountState == environment.expiredAccId) {
      this.toastr.error("Cannot topup an expired account");
      return;
    }

    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.toastr.error("top up is only available on data plans", "Error");
      return;
    }

    this.router.navigateByUrl('/topup?acc=' + this.userdetail.i_account);
  }

  setStatus(accountState) {
    switch (accountState) {
      case 0: {
        this.planstatus = "Blocked";
        break;
      }
      case 1: {
        this.planstatus = "Active";
        break;
      }
      case 2: {
        this.planstatus = "ZeroBalance";
        break;
      }
      case 3: {
        this.planstatus = "Expired";
        break;
      }
      default: {

        break;
      }

    }

  }

}
